import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { SelectivePreloadingStrategy } from '@app/core/config/router/selective-preload-strategy';
import { PathMatchType } from '@app/util/routing';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/app/dashboard',
    pathMatch: PathMatchType.Full
  },
  {
    path: '**',
    redirectTo: '/app/dashboard',
    pathMatch: PathMatchType.Full
  }
];

const config: ExtraOptions = {
  useHash: true,
  preloadingStrategy: SelectivePreloadingStrategy
};

@NgModule({
  imports: [
    RouterModule.forRoot(routes, config)
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    }
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {
}
